<template>
  <div v-loading="isLoading" class="data-up">
    <div class="data-overall-filter">
      <el-form ref="form" :model="form" class="release-form text_align_left" :inline="true">
        <el-form-item label="发布来源:">
          <el-cascader
            v-model="form.source"
            :options="sourceOptions"
            clearable
            filterable
            :props="{ checkStrictly: true }"
          ></el-cascader>
        </el-form-item>
        <el-form-item label="查询时间:">
          <el-date-picker
            v-model="form.date"
            :unlink-panels="true"
            :editable="false"
            type="daterange"
            value-format="yyyy-M-d"
            class="release-select-time"
            range-separator="-"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
          />
        </el-form-item>
      </el-form>
      <div>
        <el-button type="primary" @click="onSubmitOverall">筛选</el-button>
        <!-- <el-button>导出数据</el-button> -->
        <ExportProgress ref="downloadDialog"></ExportProgress>
        <ExportExcel
          :config-name="$options.name"
          :excel-data="excelData"
          :is-loading="isExportLoading"
          @emit="handleExportExcel"
        ></ExportExcel>
      </div>
    </div>
    <el-table :data="tableData" style="width: 100%">
      <template slot="empty">
        <NoData></NoData>
      </template>
      <el-table-column prop="date" label="发布日期">
        <template slot-scope="scope">
          {{ scope.row.date ? scope.row.date.substr(0, 10) : '' }}
        </template>
      </el-table-column>
      <el-table-column prop="publish_count" label="发布量" />
      <el-table-column prop="read_count" label="阅读量" />
      <el-table-column prop="share_count" label="转发量" />
      <el-table-column prop="collect_count" label="收藏量" />
    </el-table>
    <el-pagination
      class="pagination"
      style="background-color: #ffffff"
      layout="total, sizes, prev, pager, next, jumper"
      :page-sizes="g_pageSizesConfig"
      :total="total"
      :page-size="pageParams.page_size"
      :current-page="pageParams.page_index"
      @current-change="handleCurrentChange"
      @size-change="handleSizeChange"
    />
  </div>
</template>
<script>
import { dateFormat } from '@/utils/time';
import {
  getArticleStatByDayApi, // 每日明细数据列表
} from '@/api/dataCenter';
import ExportExcel from '@/components/export-excel';
import ExportProgress from '@/components/export-progress';
import NoData from '@/components/no-data';
export default {
  name: 'ArticleDataEveryday',
  components: {
    ExportExcel,
    NoData,
    ExportProgress,
  },
  props: {
    sourceOptions: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      form: {
        source: [], // 发布账号
        date: null, // 查询时间
      },
      total: 1, // 总页数
      pageParams: {
        page_index: 1,
        page_size: this.g_pageSizeDefault,
      },
      tableData: [], // 表格整体数据数据
      isLoading: false,
      excelData: [],
      isExportLoading: false,
    };
  },
  created() {
    this.pageParams.page_size = this.g_pageSizeDefault;
    this.getList();
  },
  methods: {
    async getList() {
      this.isLoading = true;
      const params = {
        source: this.form.source.length >= 1 ? this.form.source[0] : 0, // 渠道， 1-公众号，2-小程序
        appid: this.form.source.length >= 2 ? this.form.source[1] : '',
        ...this.pageParams,
        start_date: this.form.date ? dateFormat(new Date(this.form.date[0]), 'YYYY-MM-dd') : '',
        end_date: this.form.date ? dateFormat(new Date(this.form.date[1]), 'YYYY-MM-dd') : '',
      };
      try {
        const res = await getArticleStatByDayApi(params);
        this.tableData = res.data;
        this.total = res.total_num;
      } catch (err) {
        this.tableData = [];
        this.total = 0;
        console.log('err', err);
        this.$message.error(`查询每日明细数据失败 ${err.message || ''}`);
      }
      this.isLoading = false;
    },
    // 筛选
    onSubmitOverall() {
      this.pageParams.page_index = 1;
      this.getList();
    },
    // 选择页
    handleCurrentChange(val) {
      this.pageParams.page_index = val;
      this.getList();
    },
    handleSizeChange(size) {
      this.pageParams.page_size = size;
      this.getList();
    },
    async handleExportExcel() {
      this.isExportLoading = true;
      this.$refs.downloadDialog.openDialog();
      this.$refs.downloadDialog.startRidiculousProgress(30);
      const params = {
        source: this.form.source.length >= 1 ? this.form.source[0] : 0, // 渠道， 1-公众号，2-小程序
        appid: this.form.source.length >= 2 ? this.form.source[1] : '',
        start_date: this.form.date ? dateFormat(new Date(this.form.date[0]), 'YYYY-MM-dd') : '',
        end_date: this.form.date ? dateFormat(new Date(this.form.date[1]), 'YYYY-MM-dd') : '',
      };
      try {
        const res = await getArticleStatByDayApi({
          page_index: 1,
          page_size: 1,
          ...params,
        });
        if (res.total_num > 50000) {
          this.$message.warning(`最大支持导出5万条数据，当前数据${res.total_num}条，请重新筛选`);
          this.$refs.downloadDialog.abortProgress();
          this.isExportLoading = false;
        } else {
          const res = await getArticleStatByDayApi({
            page_index: 1,
            page_size: 50000,
            ...params,
          });
          this.excelData = res.data.map((item) => {
            const items = { ...item };
            items.date = item.date.substr(0, 10);
            return items;
          });
          this.$refs.downloadDialog.finishProgress(500);
        }
      } catch (err) {
        this.$refs.downloadDialog.abortProgress();
        console.log('err', err);
      }
      this.isExportLoading = false;
    },
  },
};
</script>
<style scoped lang="scss">
.data-up {
  .data-overall-filter {
    margin-top: 16px;
    display: flex;
    justify-content: space-between;
  }

  .pagination {
    float: right;
    margin-top: 12px;
  }
}
</style>
